export const FC1_DOES_NOT_FIT = '庫内に収まらない';
export const FC2_TIME_VIOLATION = '時刻違反';
export const FC3_TOO_MANY_DESTINATIONS = '納入先件数オーバー';
export const FC4_TOO_MANY_PICK_UP_POINTS = '倉庫件数オーバー';
export const FC5_TOO_HEAVY = '重量オーバー';
export const FC6_PERMITTED_TRUCKS_VIOLATION = '指定車両違反';
